import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { identify } from "@/lib/analytics";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/google/callback", { session_id });
        localStorage.setItem("dap_token", r.data.token);
        identify(r.data.user);
        // Clean the hash from URL, then navigate
        window.history.replaceState(null, "", window.location.pathname);
        if (r.data.is_new) {
          toast.success(`Welcome to DAP, ${r.data.user.display_name.split(" ")[0]}!`);
          nav("/app/mediakit");
        } else {
          toast.success("Welcome back.");
          nav("/app/dashboard");
        }
        // Force a full reload so AuthProvider picks up the new token
        window.location.reload();
      } catch (err) {
        toast.error(err.response?.data?.detail || "Google sign-in failed");
        nav("/login");
      }
    })();
  }, [nav]);

  return (
    <div className="max-w-md mx-auto px-6 py-32 text-center">
      <div className="w-12 h-12 rounded-full bg-[#CCFF00] mx-auto mb-6 animate-pulse" />
      <p className="font-display font-black text-3xl tracking-tighter mb-2">Signing you in…</p>
      <p className="text-neutral-400 text-sm">One moment.</p>
    </div>
  );
}
